import { render, staticRenderFns } from "./KtvCard.vue?vue&type=template&id=36d53ff8&scoped=true"
import script from "./KtvCard.vue?vue&type=script&lang=js"
export * from "./KtvCard.vue?vue&type=script&lang=js"
import style0 from "./KtvCard.vue?vue&type=style&index=0&id=36d53ff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d53ff8",
  null
  
)

export default component.exports